module.exports = {"error":{"invalid_email":"Neispravna e-mail adresa"}}